import boids from './boids.png';
import furiganaize from './furiganaize.png';

export const funprojectslist = 
[
    {
        "id": "boid-sim",
        "name": "Boids Simulation",
        "img": boids,
        "url": "boids",
    },
    {
        "id": "furiganaizer",
        "name": "Furiganaizer",
        "img": furiganaize,
        "url": "furiganaize",
    }
]